import { TechnologyType } from '@@types/api.types';
import type { TechnologyFormData } from '@schemas/technology.schema';
import { formOptions } from '@tanstack/react-form';

export const technologyFormOptions = formOptions({
  defaultValues: {
    categoryId: '',
    description: '',
    metadata: {
      researchKeywords: [],
    },
    name: '',
    primaryDomainId: '',
    primarySubdomainId: '',
    primaryUseDescription: '',
    primaryUseId: '',
    subcategoryId: '',
    timeline: undefined,
    type: TechnologyType.HARDWARE,
  } as TechnologyFormData,
});
